import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-consulta-renavam',
  templateUrl: './consulta-renavam.component.html',
  styleUrls: ['./consulta-renavam.component.scss']
})
export class ConsultaRenavamComponent implements OnInit {

  @Input() consulta: any;
  @Input() titulo="";
  @Input() idConsulta="";
  @Input() tipoConsulta="";
  @Input() codigoControle="";
  @Output() update = new EventEmitter();

  statusMsg = null;
  status = 'info';

  @Input() token = '';

  constructor() { }

  ngOnInit() { }

  ngOnChanges() {

  }

}
